// THIS FILE IS GENERATED BY 'npm run set-env-variables'

export const environment = {
  production: true,

  // Configuration/Feature-switches:
  envName: '',
  useServiceWorker: true,
  useOffers: true,
  useQandAs: true,
  useQandASearch: true,
  useRegionPerLocale: false,
  useFeedbackPrompt: false,

  searchApi: 'https://hia-search.azurewebsites.net/search',
  searchApiKey: 'W$cXF3oi$!w9NMHUj9NTv&t*9UkuP9SjP5i8NZ^y',

  // Configuration of content
  localeLanguage: 'en',
  localeDir: 'ltr',
  localeAlternatives: 'ar:العربية, en:English, fr:Français, *:Other...',
  localeAlternativesExplanation: '* Translations via Google Translate',
  appName: 'Helpful Information App',
  appLogoUrl: 'https://www.ifrc.org/sites/default/files/styles/logo_thumbnail_375_x_210_/public/media/logo/2021-08/lebanon_red_cross_logo.png?itok=1EcmTQPW',
  mainPageHeader: '',
  mainPageIntroduction: '\n \n',
  mainPageNotification: '',
  pageAbout: '\n',
  pagePrivacy: '\n',
  mainFooter: '**Helpful Information**  \n \n',
  errorHeader: 'Data Unavailable',
  errorMessage: 'Reach out to us at: ',
  errorContactUrl: 'https://github.com/RedCross-ICT/Helpful-Information-App',
  errorRetry: 'Try again?',

  // Regions:
  regionConfig: '',
  regions: 'info',
  regionsLabels: 'Information',
  regionsSheetIds: '1peF7ZluA2Pk_H40McLSfBvkFU-I4s_9aLDyiFs50LHk',

  // Third-party tokens:
  google_sheets_api_key: 'AIzaSyAPuRXY8utR9q9kfzquL1ait0V_bIHCPdE',
  google_sheets_api_url: 'https://sheets.googleapis.com/v4/spreadsheets',
  matomoConnectionString: '',
  appInsightsConnectionString: '',
};
